import { render, staticRenderFns } from "./selfLeftMenu.vue?vue&type=template&id=c706a4ba"
import script from "./selfLeftMenu.vue?vue&type=script&lang=js"
export * from "./selfLeftMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports